/*
  business critical
*/

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();

      // TODO: FIX VALIDATIONS
      window.skipValidate = true;


      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form');

      const dataEl = this.querySelector('script[type="application/json"]');
      const parsedData = JSON.parse(dataEl.textContent);
      this.variantData = parsedData.variants;
      this.variantsImages = parsedData.variantsImages;
      //console.log("inventory management", parsedData.inventoryManagement);
      this.data = {
        variant_data: parsedData.variants,
        variant_images: parsedData.variantsImages,
        formatted: parsedData.formatted,
        inventory: parsedData.inventoryManagement,
        stock_by_id: {},
        disable_single_piece: parsedData.disableSinglePiece,
        product_color_variants: parsedData.productColorVariants,
      };


      for (const size in this.data.inventory) {
        const packSizes = this.data.inventory[size];
        for (const packSize in packSizes) {
          const variantsArray = packSizes[packSize];
          variantsArray.forEach(variant => {
            const variant_id = variant.variant_id;
            const quantity = variant.quantity;
            this.data.stock_by_id[variant_id] = quantity;
          });
        }
      }
      this.variantData.forEach((variant) => {
        var variantIdStr = variant.variantId.toString();
        var stockQuantity = this.data.stock_by_id[variantIdStr];
        if (stockQuantity !== undefined) {
          variant.quantity = stockQuantity;
        } else {
          variant.quantity = 0;
        }
      });

      this.groupedVariants = {};
      this.selectedSize = null;
      this.selectedPackSize = null;
      this.selectedVariant = parsedData.selectedVariant;
      window.productSelectedVariant = this.selectedVariant;

      this.selectedVariantQuantity = null;

      this.sizeOptionsContainer = this.querySelector('.size-options');
      this.packSizeOptionsContainer = this.querySelector('.pack-size-options');
      this.price = this.section.querySelector('.product-price .price');

      this.groupVariantsBySize();
      this.renderSizeOptions();
      this.initializeSelections();
      this.updateAddToCartButton();

      this.addEventListener('change', this.handleVariantChange.bind(this));
      this.setAttribute('loaded', '');

      //this.locale = window.querySelector('html').getAtrribute('lang');
    }

    // start compatibility scripts
    getSelectedVariant() {
      return false;
    }

    getSelectedOptions() {
      return false;
    }

    handleVariantChange() {
      window.productSelectedVariant = this.selectedVariant;
    }
    // end compatibility scripts

    groupVariantsBySize() {
      this.variantData.forEach(variant => {
        const { size } = variant;
        if (!this.groupedVariants[size]) {
          this.groupedVariants[size] = [];
        }
        this.groupedVariants[size].push(variant);
      });
    }

    renderSizeOptions() {
      Object.keys(this.groupedVariants).forEach(size => {
        const button = document.createElement('button');
        button.classList.add('opt-label', 'opt-label--btn', 'btn', 'relative', 'text-center');
        button.textContent = size;
        button.dataset.size = size;
        const firstChildKey = Object.keys(this.data.inventory[size])[0];
        let currentStockLevel = this.data.inventory[size][firstChildKey][0].quantity;
        if (currentStockLevel == 0) button.classList.add('is-unavailable');
        button.addEventListener('click', () => this.onSizeSelected(size));
        this.sizeOptionsContainer.appendChild(button);
      });
    }

    onSizeSelected(size) {
      this.selectedSize = size;
      this.selectedPackSize = null;
      this.selectedVariant = null;

      this.highlightSelectedSize(size);
      this.renderPackSizeOptions(size);

      document.querySelector('.variant-size-selected-label').textContent = size;

      const packSizes = this.getPackSizesForSize(size);
      //console.log(packSizes[0]);
      if (packSizes) {
        this.onPackSizeSelected(packSizes[0]);
      }
      /*if (packSizes.includes('1')) {
        this.onPackSizeSelected('1');
      }
      else if (packSizes.includes('2')) {
        this.onPackSizeSelected('2');
      }
      else if (packSizes.includes('3')) {
        this.onPackSizeSelected('3');
      }*/
    }

    highlightSelectedSize(size) {
      const buttons = this.sizeOptionsContainer.querySelectorAll('button');
      buttons.forEach(button => {
        button.classList.toggle('selected', button.dataset.size === size);
      });
    }

    convertToArabicNumerals(num) {
      //const arabicNumerals = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
      return String(num)
      //.split('')
      //.map(digit => arabicNumerals[Number(digit)])
      //.join('');
    }

    renderPackSizeOptions(size) {
      // RENDER PACK SIZE OPTIONS

      this.packSizeOptionsContainer.innerHTML = '';
      const variants = this.groupedVariants[size];

      variants.forEach(variant => {
        const button = document.createElement('label');
        let currentStockLevel = this.data.inventory[size][variant.packSize][0].quantity;
        let variantId = variant.variantId;
        let variantPriceFormatted = this.data.formatted[variantId].price;
        let variantCompareAtPriceFormatted = this.data.formatted[variantId].compareAtPrice ?? '';
        let onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

        button.classList.add("opt-label", "packs", "opt-label--btn", "btn", "relative", "text-center");
        button.setAttribute('data-stock-level', currentStockLevel);

        let variantPackSize = variant.packSize;
        let pieceString = "Piece";
        if (parseInt(variantPackSize) > 1) {
          pieceString = "Pieces";
        }
        let finalPieceString = `<span class="js-value">${variantPackSize}</span><span> ${pieceString}</span>`;
        if (document.querySelector('html').getAttribute('lang') == 'ar') {
          if (parseInt(variantPackSize) < 2) {
            finalPieceString = `<span>قطعة</span>`;
          }
          else {
            variantPackSize = this.convertToArabicNumerals(variantPackSize);
            finalPieceString = `<span class="js-value">${variantPackSize}</span><span> قطع</span>`;
          }
        }

        button.innerHTML = `
          <div class="flex justify-between pack">
            <div class="box-info">
              <div class="value_name">
                ${finalPieceString}
              </div>
              <variant-price class="variant-price">
                <div class="box-price" data-variant="${variantId}">
                  <div class="price ${onSale ? 'price--on-sale' : ''}">
                    <div class="price__default">
                      <span class="price__was__save hide">
                        <span class="price__save" data-save-text="Save "></span>
                        <span class="price__was">${variantCompareAtPriceFormatted}</span>
                      </span>
                      <span class="price__current">${variantPriceFormatted}</span>
                    </div>
                    <div class="unit-price" hidden="">
                      <span class="visually-hidden">Unit price</span>
                      <span class="unit-price__price"></span>
                      <span class="unit-price__separator"> / </span>
                      <span class="unit-price__unit"></span>
                    </div>
                    <div class="price__no-variant" hidden="">
                      <strong class="price__current">Unavailable</strong>
                    </div>
                  </div>
                </div>
              </variant-price>
            </div>
            ${(variant.packSize > 1) ? `
              <div class="box-save">
                <span>${this.data.formatted[variantId].variantSave}</span>
              </div>` : ``
          }
          </div>
        `;
        button.dataset.packSize = variant.packSize;
        if (currentStockLevel == 0) button.classList.add('is-unavailable');
        if (variant.packSize == 1 && this.data.disable_single_piece == "true") {

        }
        else {
          button.addEventListener('click', () => this.onPackSizeSelected(variant.packSize, variant.quantity));
          this.packSizeOptionsContainer.appendChild(button);
        }
      });
    }

    getPackSizesForSize(size) {
      return this.groupedVariants[size].map(v => v.packSize);
    }

    updateVariantTemplate() {
      // DISCOUNT BADGE UPDATER

      const variantId = this.selectedVariant.variantId;
      if (variantId) {
        const templateScript = document.querySelector(`script[type="text/template"][data-variant="${variantId}"]`).innerHTML.trim();
        const container = document.querySelector('.product-label-list');
        const existingContainer = container.querySelector('.product-label-container');
        if (existingContainer) existingContainer.remove();
        if (templateScript) container.innerHTML += templateScript;
      }

    }

    onPackSizeSelected(packSize, variantQuantity) {
      // PACK SELECTION UPDATER

      this.selectedPackSize = packSize;

      document.querySelector('.variant-pack-size-selected-label').textContent = packSize;

      this.highlightSelectedPackSize(packSize);
      this.selectedVariant = this.groupedVariants[this.selectedSize].find(
        v => v.packSize === packSize
      );

      this.updateVariantImage();
      this.updatePriceDisplay();
      this.updateStockLimiter(variantQuantity);
      this.updateUrl();
      this.updateAddToCartButton();

      // TABBY PATCH
      if (document.querySelector('#tabbyPromo')) {
        //console.log(variantSpecs[this.selectedVariant.variantId]);
        document.querySelector('#tabbyPromo').setAttribute('data-tabby-price', variantSpecs[this.selectedVariant.variantId]);
        initTabbyPromotions();
      }
      this.updateColorUrl();
    }

    updateColorUrl() {
      if (this.selectedVariant) {
        // UPDATE COLOR LINK
        let current_variant = this.selectedVariant;
        let product_color_variants = this.data.product_color_variants;
        let color_value_image_a = document.querySelectorAll('.color_value_image a');
        color_value_image_a.forEach(function (product_color) {
          var product_color_id = product_color.getAttribute('data-product_color_variant');
          if (product_color_id) {
            if (product_color_variants[product_color_id][current_variant.size + '-' + current_variant.packSize]) {
              product_color.setAttribute('href', product_color_variants[product_color_id][current_variant.size + '-' + current_variant.packSize]);
            } else {
              product_color.setAttribute('href', product_color_variants[product_color_id]['available_variant']);
            }
          }
          product_color.addEventListener('click', () => window.localStorage.setItem('product_color_variants_target', window.scrollY));
        });
      }
    }

    updateStockLimiter(variantQuantity) {
      document.querySelector('#limit-quantity').value = variantQuantity;
    }

    highlightSelectedPackSize(packSize) {
      // ADDS SELECTED PACK OUTLINE

      const buttons = this.packSizeOptionsContainer.querySelectorAll('label');
      buttons.forEach(button => {
        button.classList.toggle('selected', button.dataset.packSize === packSize);
      });
    }

    updateVariantImage() {
      // GALLERY UPDATER, TRIGGERS MANUAL PATCHER

      if (this.selectedVariant && this.selectedVariant.image_id) {
        this.bringGalleryItemToFirstPosition(this.selectedVariant.image_id);
      }
    }

    updatePriceDisplay() {
      // VISUAL PRICE UPDATER

      if (this.selectedVariant) {
        this.updateVariantTemplate();

        const variant = {
          id: this.selectedVariant.variantId,
          price: this.selectedVariant.price,
          compare_at_price: this.selectedVariant.compare_at_price,
        };

        if (variant) {
          const priceCurrentEl = this.price.querySelector('.price__current');
          const priceWasEl = this.price.querySelector('.price__was');
          const priceSaveEl = this.price.querySelector('.price__save');
          const unitPriceEl = this.price.querySelector('.unit-price');
          const priceWasSaveEl = this.price.querySelector('.price__was__save');

          //console.log(variant);
          if (this.data.formatted[variant.id]) {
            priceCurrentEl.innerHTML = this.data.formatted[variant.id].price;
            if (priceSaveEl) {
              if (variant.compare_at_price > variant.price) {
                priceWasSaveEl.classList.remove('hide');
                priceWasEl.innerHTML = this.data.formatted[variant.id].compareAtPrice;
                priceSaveEl.innerHTML = `<span>${priceSaveEl.getAttribute('data-save-text')}${this.data.formatted[variant.id].savePrice}</span>`;
              } else {
                priceWasSaveEl.classList.add('hide');
                priceWasEl.innerHTML = '';
                priceSaveEl.innerHTML = '';
              }
            }
            const jsVariantSave = document.querySelector('.js-variant-save');
            if (jsVariantSave) {
              jsVariantSave.textContent = this.data.formatted[variant.id].variantSave;
              jsVariantSave.classList.remove('red', 'green');
              jsVariantSave.classList.add(this.data.formatted[variant.id].variantSaveClass);

              const selector = jsVariantSave.closest('.option-selector');
              const optLabel = selector.querySelector('.opt-label.selected');
              const boxSave = optLabel.querySelector('.box-save span');
              if (boxSave) {
                boxSave.textContent = this.data.formatted[variant.id].variantSave;
              }
            }
            if (variant.unit_price_measurement) {
              const valueEl = this.price.querySelector('.unit-price__price');
              const unitEl = this.price.querySelector('.unit-price__unit');
              const value = variant.unit_price_measurement.reference_value;
              const unit = variant.unit_price_measurement.reference_unit;

              valueEl.innerHTML = this.data.formatted[variant.id].unitPrice;
              unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
              unitPriceEl.hidden = false;
            } else if (unitPriceEl) {
              unitPriceEl.hidden = true;
            }

            this.price.classList.toggle('price--on-sale', variant.compare_at_price > variant.price);
          }
        }
      }
    }

    updateAddToCartButton() {
      // CART BUTTON UPDATE AFTER VARIANT CHANGE OR ON INIT

      if (!this.productForm) return;

      if (!this.selectedVariant) {
        this.addBtn.disabled = true;
        this.addBtn.textContent = unavailableStr;
        const addBtnSticky = document.querySelector('.sticky-atc__buttons [name="add"]');
        if (addBtnSticky) {
          addBtnSticky.setAttribute("disabled", "");
        }
        return;
      }

      //console.log(this.selectedVariant);

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.data.stock_by_id[this.selectedVariant.variantId] > 0;

      // TODO: Based on this.data.stock_by_id[this.selectedVariant.variantId] add cart buy limiter   

      const unavailableStr = theme.strings.noStock;

      this.addBtn.disabled = !variantAvailable;
      this.addBtn.textContent = variantAvailable
        ? this.addBtn.dataset.addToCartText
        : unavailableStr;

      // TODO: Fix sticky cart button data (reuse implementation from variant-picker.js or override IDs)

      const addBtnSticky = document.querySelector('.sticky-atc__buttons [name="add"]');
      if (addBtnSticky) {
        let stickyForm = addBtnSticky.closest('form');
        let idInputSticky = stickyForm.querySelector('input[name="id"]');
        let stickyVariantSelection = document.querySelector('.sticky-atc__details__variant__title');

        stickyVariantSelection.innerHTML = `
          <span>${locale.size}: ${this.selectedVariant.size}</span>
          <span>${locale.pack_size}: ${this.selectedVariant.packSize}</span>
        `;

        let stickyBtnImage = document.querySelector('.sticky-atc__image img');

        if (stickyBtnImage) {
          stickyBtnImage.removeAttribute('src');
          stickyBtnImage.removeAttribute('srcset');
          stickyBtnImage.setAttribute('src', this.selectedVariant.image);
        }

        if (idInputSticky) {
          idInputSticky.value = this.selectedVariant.variantId;
        }

        if (variantAvailable) {
          if (addBtnSticky.hasAttribute("disabled")) addBtnSticky.removeAttribute("disabled");
        } else {
          addBtnSticky.setAttribute("disabled", "");
        }
      }

      let idInput = this.productForm.querySelector('input[name="id"]');

      if (idInput) {
        idInput.value = this.selectedVariant.variantId;
      }
    }

    updateUrl() {
      // UPDATE WITH VARIANT URL

      if (this.selectedVariant) {
        const url = new URL(window.location);
        url.searchParams.set('variant', this.selectedVariant.variantId);
        window.history.replaceState({}, '', url);
      }
    }

    initializeSelections() {
      // PICKER ENTRYPOINT

      const urlParams = new URLSearchParams(window.location.search);
      const variantIdParam = urlParams.get('variant');
      let initialVariant;

      if (variantIdParam) {
        initialVariant = this.variantData.find(v => v.variantId == variantIdParam);
      }

      if (initialVariant) {
        this.selectedSize = initialVariant.size;
        this.selectedPackSize = initialVariant.packSize;
        this.highlightSelectedSize(this.selectedSize);
        this.renderPackSizeOptions(this.selectedSize);
        this.highlightSelectedPackSize(this.selectedPackSize);
        this.selectedVariant = this.groupedVariants[this.selectedSize].find(
          v => v.packSize === this.selectedPackSize
        );
        this.updateVariantImage();
        this.updatePriceDisplay();
      } else {
        const sizes = Object.keys(this.groupedVariants);
        let selectedSize = sizes[0];
        let selectedPackSize = null;
        let productSizeOpenedByDefault = localStorage.getItem('product_size_opened_by_default');
        if (productSizeOpenedByDefault) {
          const variantsForSizeDefault = this.groupedVariants[productSizeOpenedByDefault];
          let availableVariantDefault = variantsForSizeDefault.find(variant => variant.quantity > 0);
          if (this.data.disable_single_piece === "true") {
            availableVariantDefault = variantsForSizeDefault.find(variant => variant.quantity > 0 && variant.packSize !== "1");
          }
          if (availableVariantDefault) {
            selectedSize = productSizeOpenedByDefault;
            selectedPackSize = availableVariantDefault.packSize;
          }
        }
        if (selectedPackSize == null) {
          for (let size of sizes) {
            const variantsForSize = this.groupedVariants[size];
            let availableVariant = variantsForSize.find(variant => variant.quantity > 0);
            if (this.data.disable_single_piece === "true") {
              availableVariant = variantsForSize.find(variant => variant.quantity > 0 && variant.packSize !== "1");
            }
            if (availableVariant) {
              selectedSize = size;
              selectedPackSize = availableVariant.packSize;
              break;
            }
          }
        }

        this.selectedSize = selectedSize;
        this.renderPackSizeOptions(this.selectedSize);
        if (selectedPackSize !== null) {
          this.selectedPackSize = selectedPackSize;
          this.highlightSelectedSize(this.selectedSize);
          this.highlightSelectedPackSize(this.selectedPackSize);
          this.selectedVariant = this.groupedVariants[this.selectedSize].find(
            v => v.packSize === this.selectedPackSize
          );
          this.updateVariantImage();
          this.updatePriceDisplay();
        }
        else {
          //this.selectedVariant = {} 
          //this.selectedVariant.id = productSelectedVariant;
          //this.updatePriceDisplay();
          // RENDER CART BUTTON LOCKED
          this.updateAddToCartButton();
        }
      }
      let selectedPackButton = document.querySelector('label.packs.selected');
      if (selectedPackButton) selectedPackButton.click();
    }

    bringGalleryItemToFirstPosition(dataMediaId) {
      // GALLERY PATCHER

      this.variantsImages.forEach(function (imageId) {
        if (imageId != dataMediaId) {
          document.querySelectorAll('.template-product [data-media-id="' + imageId + '"]').forEach(function (mediaItem) {
            mediaItem.setAttribute('hidden', '');
          });
        }
        document.querySelectorAll('.template-product [data-media-id="' + dataMediaId + '"]').forEach(function (mediaItem) {
          mediaItem.removeAttribute('hidden');
        });

        if (imageId != dataMediaId) {
          document.querySelectorAll('.media-gallery [data-media-id="' + imageId + '"]').forEach(function (mediaItem) {
            mediaItem.setAttribute('hidden', '');
          });
        }
        document.querySelectorAll('.media-gallery [data-media-id="' + dataMediaId + '"]').forEach(function (mediaItem) {
          mediaItem.removeAttribute('hidden');
        });
      });

      var parentDivs = document.querySelectorAll('.u-product-image-gallery');
      parentDivs.forEach(function (parent) {
        var element = parent.querySelector('[data-media-id="' + dataMediaId + '"]');
        if (element) {
          var currentActiveItem = parent.querySelector('.is-active');
          if (currentActiveItem) {
            currentActiveItem.classList.remove('is-active');
            currentActiveItem.setAttribute('tabindex', '-1');
          }
          element.classList.add('is-active');
          element.removeAttribute('tabindex');
          parent.removeChild(element);
          parent.insertBefore(element, parent.firstChild);
        }
      });


      var parentDivs = document.querySelectorAll('.u-product-image-gallery-viewer');
      parentDivs.forEach(function (parent) {
        var element = parent.querySelector('[data-media-id="' + dataMediaId + '"]');
        if (element) {
          var currentActiveItem = parent.querySelector('.gallery-viewer__thumb--active');
          if (currentActiveItem) {
            currentActiveItem.classList.remove('gallery-viewer__thumb--active');
          }
          element.classList.add('gallery-viewer__thumb--active');
          parent.removeChild(element);
          parent.insertBefore(element, parent.firstChild);
        } else {
          console.warn('Element with data-media-id="' + dataMediaId + '" not found in this container.');
        }
      });

      this.refreshAllCarousels();
    }

    refreshAllCarousels() {
      // FIXES ALL GLITCHES ON THE GALLERY AFTER MANUAL PATCHING

      document.querySelectorAll('carousel-slider').forEach(slider => {
        if (typeof slider.refresh === 'function') {
          slider.refresh();
        } else {
          console.warn('The refresh method is not defined on carousel-slider.');
        }
      });
    }
  }

  customElements.define('variant-picker', VariantPicker);
}